// extracted by mini-css-extract-plugin
export var logo = "HackawaySection-module--logo--1Vw4X";
export var hackawayHeroSection = "HackawaySection-module--hackawayHeroSection--3w4Dc";
export var container = "HackawaySection-module--container--1Mman";
export var subtitle = "HackawaySection-module--subtitle--TUD7x";